<template>
	<div>
		<TableList v-bind="getData" @on-radio-change="checkChange"></TableList>
		<div class="text-right margin-top-15">
			<vButton @click="click" theme="primary">{{$t('global.common.update_OK',{defaultValue:'确定'})}}</vButton>
			<vButton class="margin-left-10" @click="cancel" >{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</vButton>
		</div>
	</div>
</template>
<script>
import { HttpDeliveryList,HttpReceiveList } from "@/service/bespeak";
import TableList from "@components/templates/tablelist"
import { mapState,mapGetters,mapMutations } from "vuex";
export default {
	props:['addresstype',],
	components: {
		TableList
	},
	methods: {
		checkChange(rows, val) {
			// console.log(rows)
			this.rows = rows
		},
		click() {
			this.$emit('rows', this.rows)
		},
		cancel(){
			this.$emit('cancel')
		},
	},
	computed: {
        ...mapGetters('dictionary', ['getNextOrgList']),
		getData() {
            let dataarr = [];let chosetype = null; let columns = [];
            if(this.addresstype == 'delivery'){
                chosetype = 0;
                dataarr = [
                    {
                        label: '发货地址名称',
                        tag: 'vInput',
                        key: 'EQ_addressCode',
                        show: true,
                    },
                    {
                        label: '发件人',
                        tag: 'vInput',
                        key: 'CN_linkman',
                        show: true,
                    },
                ];
                columns =[{
					type: 'selection',
					width: 50,
					align: "center",
					formName: 'id',
					isRadio:true,
				},
                {
                    title: '发货地址名称',
                    key: 'addressCode',
                },
                {
                    title: '发货地址',
                    key: 'address',
                },
                {
                    title: '城市',
                    key:'city',
                },
                {
                    title: '州',
                    key:'state',
                },
                {
                    title: '国家',
                    key:'country',
                },
                {
                    title: '邮编',
                    key:'postal',
                },
                {
                    title: '发件人',
                    key:'linkman',
                },
                {
                    title: '联系电话',
                    key:'phone',
                },]
            }else{
                chosetype = 1;
                dataarr = [
                    {
                        label: '客户',
                        tag: 'vSelect',
                        key: 'EQ_orgId',
                        options:this.getNextOrgList,
                        show: true,
                    },
                    {
                        label: '目的地地址Code',
                        tag: 'vInput',
                        key: 'CN_addressCode',
                        show: true,
                    },
                ];
                columns = [{
					type: 'selection',
					width: 50,
					align: "center",
					formName: 'id',
					isRadio:true,
				},{
                    title: '客户',
                    key: 'orgId',
                    render: (h, { row }) => this.findRenderLabel(this.getNextOrgList, row.orgId),
                },
                {
                    title: '目的地地址Code',
                    key: 'addressCode',
                },
                {
                    title: '目的地地址',
                    key:'address',
                },
                {
                    title: '城市',
                    key:'city',
                },
                {
                    title: '州',
                    key:'state',
                },
                {
                    title: '国家',
                    key:'country',
                },
                {
                    title: '邮编',
                    key:'postal',
                },
                {
                    title: '收件人',
                    key:'linkman',
                },
                {
                    title: '联系电话',
                    key:'phone',
                },]
            }
			return {
				ajaxRequest: this.addresstype==0 ? HttpDeliveryList:HttpReceiveList,
				startUp: true,
				Searchs: {
					show: true,
					style: "border:none;",
					align: "left"
				},
                initFormData: {
					'type':chosetype,
                    search:{
                        'EQ_active':0
                    }
				},
                interceptRequest(params){
                    params.search.EQ_active = 0
                    return params
                },
				SearchsData: dataarr,
				columns: columns,
			}
		}
	},
}
</script>